/** 사용량 탭 — the app's own telemetry (S3, `/apps/:id/usage`).
 *
 *  The same panel as `/analytics/:appId`, on the same default window (one day,
 *  plan D9; the old tab opened on 30). The window lives in `?days`, an explicit
 *  value always wins. The panel is the one of `routes/analytics/`. */

import { useSearchParams } from 'react-router-dom'
import { AnalyticsPanel } from '../analytics/AnalyticsPanel'
import { WINDOWS } from '../analytics/format'
import type { App } from '@/api/client'

export const USAGE_DEFAULT_DAYS = 1

export function UsageTab({ app }: { app: App }) {
  const [params, setParams] = useSearchParams()
  const raw = Number(params.get('days'))
  const days = WINDOWS.includes(raw) ? raw : USAGE_DEFAULT_DAYS
  return (
    <AnalyticsPanel
      appId={app.bundle_id}
      days={days}
      onDaysChange={(d) => {
        const next = new URLSearchParams(params)
        if (d === USAGE_DEFAULT_DAYS) next.delete('days')
        else next.set('days', String(d))
        setParams(next, { replace: true })
      }}
    />
  )
}
